<template>
    <aside class="oy-a pf ath-modal">
        <div class="pa-f ath-modal-bg"
            :class="[UIMobile ? 'c-el-panel-bg' : 'c-el-overlay-dark-bg el--animate']"></div>
        <div class="f fv fa-c fj-c oy-a pa-f ath-modal-container"
            :class="[UIMobile ? 'c-el-panel-bg ox-h' : '']">
            <div class="ath-modal-el"
                ref="modalElement"
                tabindex="-1"
                :class="[UIMobile ? 'el--mobile' : '']"
                @keydown.esc="onEscape"
                @keydown.tab="onTabKey">
                <slot name="content"></slot>
            </div>
        </div>
    </aside>
</template>

<script>
import UIMobileMixin from '../../../mixins/UIMobile';

const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea:not([disabled]), '
    + 'input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * This modal is meant to be used in contrast to the global modal. It requires its parent to create it.
 */
export default {
    name: 'mead-standalone-modal',
    mixins: [UIMobileMixin],
    data () {
        return {
            previouslyFocusedElement: null,
        };
    },
    methods: {
        getFocusableEls () {
            return Array.from(this.$refs.modalElement.querySelectorAll(FOCUSABLE_SELECTOR))
                .filter(el => el.offsetParent !== null);
        },
        onEscape (event) {
            this.$emit('close', event);
        },
        onTabKey (event) {
            const focusable = this.getFocusableEls();
            if (focusable.length === 0) {
                event.preventDefault();
                return;
            }

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        },
    },
    mounted () {
        this.previouslyFocusedElement = document.activeElement;
        this.$nextTick(() => {
            const focusable = this.getFocusableEls();
            (focusable[0] || this.$refs.modalElement).focus();
        });
    },
    beforeDestroy () {
        if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
            this.previouslyFocusedElement.focus();
        }
    },
};
</script>
<style lang="scss" scoped>
@use '../../../../sass/variables' as *;

.ath-modal {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: $zx-modal;
}

.ath-modal-bg {
    z-index: calc(#{$zx-page-overlay} - 1);

    &.el--animate {
        opacity: .8;
        animation: overlayBgIn .2s forwards ease-out;
    }
}

.ath-modal-container {
    z-index: $zx-page-overlay;
}

.ath-modal-el {
    &:focus-visible {
        outline: 2px solid var(--c-panel-border-active);
        outline-offset: -2px;
    }

    &.el--mobile {
        width: 100vw !important;
        height: 100% !important;
        max-height: 100% !important;
        padding-top: 0;
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
    }

    &:not(.el--mobile) {
        opacity: 0;
        animation: modalIn .2s forwards ease-out;
        transform: translateY(-2rem);
        max-height: 100%;
        max-width: 100%;
        border-radius: $br-m;
    }
}
</style>
